<template>
    <BreadCrumb PageTitle="Télécharger un manifest" />
    <UploadManifest />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import UploadManifest from "@/components/Manifest/UploadManifest.vue";

    export default defineComponent({
        name: "UploadManifestPage",
        components: {
            BreadCrumb,
            UploadManifest,
        },
    });
</script>
